import Vue from 'vue';
import store from './store';
import ossUpload from '@/assets/script/lib/oss/upload'
import {cryptoJs, cookie} from '@deanwu/vue-component-library-mobile'

let app = new Vue();

// staff [协同端]; client [客户端]
const SYS = "client";

// Alpha [开发环境]; Online [正式环境]
const RE = "Online";
const SERVER_ADDR = (re => {
	switch(re) {
		case 'Local':
		case 'Alpha':
			return '/develop';
		case 'Online':
			return '/api';
	}
})(RE);

var loginTimeoutConfirm = false;

export default {
	request: {
		md5Key: 'V52kPpLS6msz7y3NfZUZ9OKFYeoGysMOeMSPdcObi6onvgmgKKEP5gk3s2omhDDOV3T6SYitc5bKUEzZECnEuN61YvObbu2SD7InNlnWeB8j7M195swDhAYjEnLAI71M',
		enKey: 'b2bc2dcff9074d84',
		deKey: '83fe4c23467507cd',
		log: RE != 'Online' || localStorage.getItem('debug') == 1,
		baseUrl: SERVER_ADDR,
		timeout: 60000,
		dataFormatter(data) {
			data.client = SYS == 'staff' ? 3 : 4;
			data.session = store.state.session;
			return data;
		},
		response(data, requestQueue) {
			let message;
			switch (data.code) {
			case 9403:
			case 9405:
				message = '登录状态已失效，请重新登录';
				break;
			
			case 9505:
				message = '您当前账号已在其他设备登录，当前登录被强制退出，如不是本人操作，请及时修改密码';
				break;
			}
			if (message) {
				if (!loginTimeoutConfirm) {
					loginTimeoutConfirm = true;
					app.$confirm({
						message,
						buttonName: '重新登录',
						cancelButton: false,
						resolve: () => {
							if (RE == 'Local' && store.state.ENV != 'mp') {
								$app.request({
									url: '/sys_user/login',
									data: {
										user_name: 'wudi',
										user_pwd: cryptoJs.MD5('123456').toString(),
									},
									loading: true,
									success: data => {
										$app.$store.dispatch('setLoginInfo', data);
										window.location.reload();
									}
								});
								return;
							}

							app.globalDialogDestroy();
							$app.$store.commit('setSession', '');
							$app.mp.reLaunch('/pages/entry');
							loginTimeoutConfirm = false;
						}
					});
				}
				for (let i in requestQueue) {
					requestQueue[i].abort();
				}
				return false;
			}
		}
	},
	
	theme: {
		main: '#00A1E9',
		mainHover: '#00A1E9',
		lesser: '#0D6EFE',
		lesserHover: '#3F8FFF',
		adorn: '#FF3333'
	},

	color: {
		red: ['#FF5555', '#FF3E3E'],
		green: ['#07B461', '#0AB462'],
		blue: ['#0D6EFE', '#2E7FFF'],
		yellow: ['#FFAB17', '#F89E00'],
		orange: ['#FF8A00', '#FF8A00']
	},
	
	style: {
		buttonSize: {
			detail: {
				'height': '.72rem',
				'border-radius': '.08rem',
				'padding': '0 .2rem',
				'font-size': '.3rem'
			}
		}
	},
	
	empty: {
		normal: {
			icon: 'https://ylserver-2025-online.oss-cn-shanghai.aliyuncs.com/app_static/empty/common.png',
			message: '暂无数据'
		},
	},

	config: {
		title: {
			icon: 'tf-title'
		},

		select: {
			listHeight: '70vh'
		},

		file: {
			uploadHandle(files, success) {
				ossUpload(files, {
					success
				});
			},
			
			openEvent(src) {
				if ($app.$store.state.ENV == 'app') {
					let loading = $app.$loading({
						timeout: false
					});
					$app.JSBridge('openFile', src, () => {
						loading.close();
					});
				} else {
					window.open(src);
				}
			}
		},

		form: {
			eachExclName: ['detailCard'],
			breakWhenFail: false
		}
	},
	
	data: {
		authority() {
			return store.getters.allAuthKey;
		},
		
		options: {
		},
		
		region(type, parent, resolve) {
			app.request({
				url: '/address_library/region',
				data: {
					parent_id: parent.value
				},
				success: data => {
					resolve(Array.from(data, item => {
						return {
							name: item.name,
							value: item.id
						}
					}))
				}
			});
		}
	}
}

export {
	SYS,
	RE,
	SERVER_ADDR
}